import React, { Component, Fragment } from "react"
import { connect } from "react-redux"
import { bindActionCreators, compose } from "redux"
import { withRouter } from "react-router-dom"
import parse from "html-react-parser"
import { isEmpty, sortBy } from "lodash"

import Button from "components/common/Button"
import InputField from "components/input"

import {
  saveProgress,
  completeCourseware,
  startExam,
  submitAnswer,
  showResponseModal,
  closeResponseModal,
  getCoursewareById,
  setExamAsSubmitted,
  getExamDetails,
} from "store/user/actions"

import { RESPONSE_MODAL_TYPES } from "constants/modal-types"
import { ADMIN_ROLE } from "constants/auth-types"

import { paginate } from "helpers/util"

import "bulma-steps/dist/css/bulma-steps.min.css"

import styled from "styled-components"

import moment from "moment"
import CheckBox from "components/checkbox"
import FormRadio from "components/form/radio"

const HTMLContainer = styled.div`
  text-align: justify;
  a,
  input,
  textarea,
  button,
  select {
    outline: none;
  }
  a:hover,
  h1:focus,
  h2:focus,
  h3:focus,
  h4:focus,
  h5:focus,
  h6:focus {
    text-decoration: none;
  }
  a:focus,
  input:focus,
  textarea:focus,
  button:focus,
  select:focus {
    outline: none !important;
    text-decoration: none;
  }
  input,
  textarea {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    -webkit-border-radius: 0;
    -moz-border-radius: 0;
    border-radius: 0;
  }
  a {
    -webkit-transition: all 0.3s ease;
    -moz-transition: all 0.3s ease;
    -ms-transition: all 0.3s ease;
    -o-transition: all 0.3s ease;
    transition: all 0.3s ease;
  }
  img {
    max-width: 100%;
    width: auto;
    height: auto;
    vertical-align: middle;
    border: 0;
  }

  p {
    font-size: 16.8px !important;
    color: #040316;
  }

  label {
    font-weight: 400;
  }

  h1 {
    line-height: 1.618;
  }

  textarea {
    width: 100%;
    height: 100px;
    font-size: 14px;
    padding: 10px 14px;
    resize: none;
    line-height: 1.5em;
    border: 1px solid #d4d4d4;
  }

  blockquote {
    font-weight: 700;
    border-left: 3px solid #428bca;
    margin: 0 1rem;
  }
  blockquote p {
    font-style: italic;
    font-size: 14px;
  }
  blockquote cite {
    font-size: 13px;
    color: #428bca;
  }
  blockquote cite:before {
    content: "- ";
  }
  blockquote cite:after {
    content: " -";
  }
`

class Exam extends Component {
  state = {
    activeStep: 1,
    maxSteps: 10,
    fieldErrors: {},
    answerSheet: {},
    formSheet: {},
    timeLeft: 0,
    showResults: false,
    isAdminViewExam: false,
  }

  componentDidMount() {
    const { data, completeCourseware } = this.props

    let newAnswerSheet = {}

    //TODO - Fix ESLint Roles for data mapping
    let arr = data?.exam_submission?.questions.forEach((question) => {
      newAnswerSheet[question.id] = question.answer
    })

    this.setState(
      {
        answerSheet: newAnswerSheet,
        activeStep:
          parseInt(localStorage.getItem(data.id)) <= 0
            ? 1
            : parseInt(localStorage.getItem(data.id)) || 1,
      },
      () => console.log(arr)
    )

    if (
      data?.exam?.duration > 0 &&
      !isEmpty(data?.exam_submission) &&
      !data?.exam_submission?.submitted
    ) {
      this.startExamTimer()
    }

    if (data?.exam_submission?.submitted) {
      if (!data?.completed && !data?.exam_submission?.has_pending) {
        completeCourseware({ id: data.id })
      }

      this.setState({ showResults: true })
    }

    return null
  }

  isAdminRole = () => {
    const {
      auth: { role },
    } = this.props

    return ADMIN_ROLE.includes(role)
  }

  getExamDetails = () => {
    const {
      data = {},
      user: { examDetails: propsUserExam },
    } = this.props

    let examDetails = {}
    if (this.isAdminRole()) {
      examDetails = propsUserExam || {}
    } else if (!isEmpty(data?.exam_submission)) {
      examDetails = data?.exam_submission || {}
    }

    return examDetails
  }

  componentWillUnmount() {
    clearInterval(this.examTimer)
  }

  startExamTimer = () => {
    const {
      data: { exam_submission = {} },
    } = this.props

    if (this.examTimer) {
      clearInterval(this.examTimer)
    }

    this.setState({
      timeLeft: exam_submission.time_left,
    })

    this.examTimer = setInterval(() => {
      let timeLeft = this.state.timeLeft - 1

      if (timeLeft < 1) {
        clearInterval(this.examTimer)

        setTimeout(() => {
          this.handleExamTimeEnd()
        }, timeLeft * 1000)
      }

      this.setState({ timeLeft })
    }, 1000)
  }

  handleExamTimeEnd = () => {
    const {
      data: { id: coursewareId },
      showResponseModal,
      closeResponseModal,
      getCoursewareById,
    } = this.props

    let modalData = {
      header: "Oops, Sorry!",
      verified: true,
      modalType: RESPONSE_MODAL_TYPES.ERROR,
      message:
        "Timer has ended and you weren't able to finish within the time allocated for this exam.",
      actionLabel: "OK",
      action: () => {
        closeResponseModal()
      },
    }
    showResponseModal(modalData)

    setTimeout(() => {
      getCoursewareById({ id: coursewareId })
    }, 1000)
  }

  handleStartExam = (id) => {
    const { startExam } = this.props
    startExam(id)
  }

  handleToggleAdminExam = (id) => {
    const {
      getExamDetails,
      user: { examDetails },
    } = this.props

    const { isAdminViewExam } = this.state

    if (isEmpty(examDetails) || examDetails?.id !== id) {
      getExamDetails(id)
    }

    this.setState({
      isAdminViewExam: !isAdminViewExam,
      activeStep: 1,
      answerSheet: {},
    })
  }

  handleSubmitAnswer = (id, data) => {
    const { submitAnswer } = this.props

    if (this.isAdminRole()) {
      this.handleSetNextPage()
    } else {
      submitAnswer({ id, data })
    }
  }

  handleSetSelectedPage = (step) => {
    this.setState({ activeStep: step + 1 })
  }

  handleSetNextPage = () => {
    const { activeStep } = this.state
    this.setState({ activeStep: activeStep + 1 })
  }

  handleSetPreviousPage = () => {
    const { activeStep } = this.state
    this.setState({ activeStep: activeStep - 1 })
  }

  handleSelectPage = (id, step) => {
    let setPage = false
    if (this.isAdminRole()) {
      setPage = true
    } else {
      const { activeStep, maxSteps } = this.state
      const { data } = this.props

      let examQuestions = paginate(
        data?.exam_submission?.questions,
        maxSteps,
        activeStep
      )

      let activeQuestion =
        examQuestions.find((item) => item.order === step + 1) || {}

      setPage = !isEmpty(activeQuestion.answer)
    }

    if (setPage) {
      localStorage.setItem(id, step + 1)
      this.handleSetSelectedPage(step)
    }
  }

  handleNext = (activeQuestion) => {
    const { activeStep, answerSheet, formSheet } = this.state
    const { data } = this.props

    let requestData = {
      answer: answerSheet[activeQuestion.id],
    }

    const formData = new FormData()
    formData.append("answer", formSheet[activeQuestion.id])

    const examDetails = this.getExamDetails()

    if (isEmpty(answerSheet[activeQuestion.id])) {
      if (
        activeQuestion.type === "radio" ||
        activeQuestion.type === "checkbox"
      ) {
        this.validateField(activeQuestion.id, "Please select an answer")
      } else {
        this.validateField(activeQuestion.id)
      }
    } else if (activeStep === examDetails?.total_questions) {
      this.setState({ isAdminViewExam: false })

      if (activeQuestion.type === "file") {
        this.handleSubmitAnswer(activeQuestion.id, formData)
      } else {
        this.handleSubmitAnswer(activeQuestion.id, requestData)
      }
      localStorage.removeItem(data.id)
    } else {
      if (answerSheet[activeQuestion.id] !== activeQuestion.answer) {
        if (activeQuestion.type === "file") {
          this.handleSubmitAnswer(activeQuestion.id, formData)
        } else {
          this.handleSubmitAnswer(activeQuestion.id, requestData)
        }
        localStorage.setItem(data.id, activeStep + 1)
      } else {
        localStorage.setItem(data.id, activeStep + 1)
        this.handleSetNextPage()
      }
    }
  }

  handlePrevious = () => {
    const { activeStep } = this.state
    const { data } = this.props
    if (activeStep > 1) {
      localStorage.setItem(data.id, activeStep - 1)
      this.handleSetPreviousPage()
    } else {
      localStorage.setItem(data.id, 1)
    }
  }

  validateField = (name, message) => {
    const { answerSheet } = this.state
    let fieldErrors = this.state.fieldErrors

    if (isEmpty(message)) {
      message = "This field is required"
    }

    if (isEmpty(answerSheet[name])) {
      fieldErrors[name] = message
    } else {
      delete fieldErrors[name]
    }

    this.setState({ fieldErrors })
  }

  handleInputChange = (e) => {
    const { answerSheet } = this.state
    const { value, name } = e.currentTarget
    this.setState(
      {
        answerSheet: {
          ...answerSheet,
          [name]: value,
        },
      },
      () => this.validateField(name)
    )
  }

  handleSelect = (e) => {
    const { answerSheet } = this.state
    const { name, value } = e.currentTarget
    this.setState(
      {
        answerSheet: {
          ...answerSheet,
          [name]: value,
        },
      },
      () => this.validateField(name)
    )
  }

  handleSelectSingle = (name, value) => {
    const { answerSheet } = this.state
    this.setState(
      {
        answerSheet: {
          ...answerSheet,
          [name]: value,
        },
      },
      () => this.validateField(name)
    )
  }

  handleSelectMultiple = (e) => {
    const { answerSheet } = this.state
    const target = e.currentTarget
    const { value, name } = target

    if (target.checked) {
      if (isEmpty(answerSheet[name])) {
        this.setState(
          {
            answerSheet: {
              ...answerSheet,
              [name]: [value],
            },
          },
          () => this.validateField(name, "Please select an answer")
        )
      } else {
        this.setState(
          {
            answerSheet: {
              ...answerSheet,
              [name]: [...answerSheet[name], value],
            },
          },
          () => this.validateField(name, "Please select an answer")
        )
      }
    } else {
      this.setState(
        {
          answerSheet: {
            ...answerSheet,
            [name]: answerSheet[name].filter((item) => item !== value),
          },
        },
        () => this.validateField(name, "Please select an answer")
      )
    }
  }

  handleFileSelect = (e) => {
    const { answerSheet, formSheet } = this.state
    const { value, name } = e.currentTarget
    this.setState(
      {
        answerSheet: {
          ...answerSheet,
          [name]: value,
        },
        formSheet: {
          ...formSheet,
          [name]: e.target.files[0],
        },
      },
      () => this.validateField(name, "No file is chosen")
    )
  }

  handleViewResults = () => {
    const { showResults } = this.state
    this.setState({ showResults: !showResults })
  }

  handleViewFile = (value) => {
    window.open(value, "_blank")
  }

  handleViewNextCourseWare = () => {
    const { onNextCourseware = false } = this.props

    if (onNextCourseware) {
      onNextCourseware()
    }
  }

  formatAnswer = (answer) => {
    if (answer) {
      if (Array.isArray(answer)) {
        return answer.join(", ")
      } else {
        return answer
      }
    }
  }

  paginateExam = () => {
    const { activeStep, maxSteps } = this.state
    const { data: propData } = this.props

    let examQuestions = paginate(
      propData?.exam_submission?.questions,
      maxSteps,
      activeStep
    )

    let activeQuestion =
      examQuestions.find((item) => item.order === activeStep) || {}

    return activeQuestion
  }

  displayExamType = (data) => {
    const { answerSheet, fieldErrors } = this.state

    switch (data.type) {
      case "text":
        return (
          <Fragment>
            <div className="control">
              <InputField
                placeholder="Enter your answer here"
                name={data.id}
                value={answerSheet[data.id]}
                error={fieldErrors[data.id]}
                onChange={this.handleInputChange}
              />
            </div>
          </Fragment>
        )

      case "textarea":
        return (
          <Fragment>
            <InputField
              type="textarea"
              placeholder="Enter your answer here"
              name={data.id}
              value={answerSheet[data.id]}
              error={fieldErrors[data.id]}
              onChange={this.handleInputChange}
            />
          </Fragment>
        )

      case "radio":
        return (
          <Fragment>
            <div className="control exam-radio">
              <p className="choices-header">Select your answer</p>
              {data.choices?.map((item, i) => (
                <FormRadio
                  id={i}
                  key={i}
                  name={data.id}
                  checked={answerSheet[data.id]?.includes(item)}
                  onChange={() => this.handleSelectSingle(data.id, item)}
                  text={item}
                />
              ))}
            </div>
            {fieldErrors[data.id] && (
              <p className="error-message">{`* ${fieldErrors[data.id]}`}</p>
            )}
          </Fragment>
        )

      case "checkbox":
        return (
          <Fragment>
            <div className="control exam-checkbox">
              <p className="choices-header">Select your answer</p>
              <small className="choices-subheader">
                Check all possible answers.
              </small>
              {fieldErrors[data.id] && (
                <p className="error-message">{`* ${fieldErrors[data.id]}`}</p>
              )}
              {data.choices?.map((item, i) => (
                <CheckBox
                  name={data.id}
                  value={item}
                  text={item}
                  id={`chk-choice-${data.id}-${i}`}
                  checked={answerSheet[data.id]?.includes(item)}
                  onChange={this.handleSelectMultiple}
                />
              ))}
            </div>
          </Fragment>
        )

      case "select":
        return (
          <Fragment>
            <div className="exam-select">
              <p className="choices-header">Select your answer</p>
              <div className="select-wrapper" id="sort">
                <select
                  name={data.id}
                  className="select"
                  onChange={this.handleSelect}
                  value={[answerSheet[data.id]]}
                >
                  {data.answer ? (
                    ""
                  ) : (
                    <option value={null} key={-1}>
                      Select answer...
                    </option>
                  )}
                  {data.choices?.map((item, index) => (
                    <option value={item} key={index}>
                      {item}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            {fieldErrors[data.id] && (
              <p className="error-message">{`* ${fieldErrors[data.id]}`}</p>
            )}
          </Fragment>
        )

      case "file":
        return (
          <Fragment>
            <div className="file-container">
              <input
                type="file"
                name={data.id}
                onChange={this.handleFileSelect}
                required
              />
            </div>
            {data.answer && (
              <Button
                label="View File"
                ghost
                onClick={() => this.handleViewFile(data.answer)}
              />
            )}
            {fieldErrors[data.id] && (
              <p className="error-message">{`* ${fieldErrors[data.id]}`}</p>
            )}
          </Fragment>
        )

      default:
    }
  }

  renderExamAsAdmin = (examTimer, examQuestions, activeQuestion) => {
    const {
      data = {},
      school: { schoolData },
    } = this.props

    const { activeStep } = this.state

    return (
      <Fragment>
        {data.exam?.duration > 0 ? (
          <div className="exam-timer">
            <label
              className="timer-preamble"
              style={{ color: schoolData?.primary_color }}
            >
              EXAM TIMER
            </label>
            <p className="timer-countdown">{examTimer}</p>
            <p className="timer-note">
              *Timer will continue to run when you leave this page
            </p>
          </div>
        ) : (
          ""
        )}
        <p className="exam-subtitle">Question Progress</p>
        <div className="bubble-step" id="questionaires">
          {sortBy(examQuestions, ["order"])?.map((item, i) => (
            <div
              key={i}
              style={
                item.order === activeStep
                  ? {
                      borderColor: schoolData.primary_color,
                      backgroundColor: "#ffffff",
                      color: schoolData.primary_color,
                      height: "32px",
                      width: "32px",
                    }
                  : item.answer
                  ? {}
                  : {}
              }
              className="step-item"
              onClick={() => this.handleSelectPage(data.id, i)}
            >
              {item.order}
            </div>
          ))}
        </div>
        <div className="bubble-content">
          {this.renderQuestion(activeQuestion)}
          {this.displayExamType(activeQuestion)}
        </div>
        <div className="steps-actions">
          <div className="steps-action">
            <Button
              label="Previous Question"
              ghost
              outlined
              hidden={activeStep <= 1}
              disabled={activeStep <= 1}
              onClick={() => this.handlePrevious()}
            />
          </div>
          <div className="steps-action">
            <Button
              label={
                activeStep === data?.exam_submission?.questions.length
                  ? "Submit Exam"
                  : "Next Question"
              }
              onClick={() => this.handleNext(activeQuestion)}
            />
          </div>
        </div>
      </Fragment>
    )
  }

  renderQuestion = (question = {}) => {
    const points = `${question?.points} point${question.points > 1 ? "s" : ""}`

    return (
      <>
        <p className="points">{points}</p>
        <p className="question">Question:</p>
        <HTMLContainer>{parse(question.text || "")}</HTMLContainer>
      </>
    )
  }

  render() {
    const {
      data = {},
      school: { schoolData },
      auth: { role },
      user: { examDetails },
    } = this.props

    const { activeStep, maxSteps, showResults, timeLeft, isAdminViewExam } =
      this.state

    const IS_ADMIN_ROLE = this.isAdminRole()

    let examQuestions = [],
      activeQuestion = {}
    if (IS_ADMIN_ROLE) {
      if (!isEmpty(examDetails)) {
        examQuestions = paginate(examDetails?.questions, maxSteps, activeStep)

        activeQuestion =
          examQuestions.find((item) => item.order === activeStep) || {}
      }
    } else if (!isEmpty(data?.exam_submission)) {
      examQuestions = paginate(
        data?.exam_submission?.questions,
        maxSteps,
        activeStep
      )

      activeQuestion =
        examQuestions.find((item) => item.order === activeStep) || {}
    }

    let examTimer = false
    if (data.exam?.duration > 0 && timeLeft > 0) {
      let duration = moment.duration(timeLeft, "seconds")
      examTimer =
        (duration.hours() < 10 ? "0" : "") +
        duration.hours() +
        ":" +
        (duration.minutes() < 10 ? "0" : "") +
        duration.minutes() +
        ":" +
        (duration.seconds() < 10 ? "0" : "") +
        duration.seconds()
    }

    const maxAttemptReached = data?.exam?.max_attempts
      ? data?.exam?.max_attempts === data?.exam_submission?.attempt
      : false
    const showExplanation = data?.exam?.max_attempts
      ? data?.exam_submission?.passed || maxAttemptReached
      : data?.exam_submission?.passed
    const showCorrectAnswer = showExplanation && !activeQuestion?.is_correct

    return (
      <>
        <div className="courseware-details">
          <h2 className="courseware-title">{`${data.name}`}</h2>
          {data.description ? (
            <p className="courseware-description">{data.description}</p>
          ) : (
            ""
          )}
        </div>
        <div
          className={`exam-wrapper ${
            isEmpty(data?.exam_submission) || data?.exam_submission?.submitted
              ? ""
              : ""
          } ${showResults ? "-results" : ""}`}
        >
          {showResults ? (
            <>
              <div className="result-header">
                <div>
                  {data?.exam_submission?.has_pending ? (
                    <>
                      <h3 className="exam-message">
                        {`Your current score is ${data?.exam_submission?.total_score} out of ${data?.exam_submission?.total_points}`}
                      </h3>
                      <p className="is-italic">
                        There are items still pending for checking.
                      </p>
                    </>
                  ) : (
                    <h3 className="exam-message">
                      {`Your score is ${data?.exam_submission?.total_score} out of ${data?.exam_submission?.total_points}`}
                    </h3>
                  )}
                </div>
                <div
                  className="exam-percentage"
                  style={
                    data?.exam_submission?.passed
                      ? { backgroundColor: "rgba(24, 204, 3, 0.18)" }
                      : {
                          backgroundColor: "rgba(249, 0, 55, 0.18)",
                        }
                  }
                >
                  <p
                    className="initials"
                    style={
                      data?.exam_submission?.passed
                        ? { color: "rgb(24, 204, 3)" }
                        : {
                            color: "rgb(249, 0, 55)",
                          }
                    }
                  >
                    {data?.exam_submission?.score !== null
                      ? `${(data?.exam_submission?.score || 0).toFixed(1)}%`
                      : ""}
                  </p>
                </div>
              </div>
              <p className="exam-subtitle">Question Progress</p>
              <div className="bubble-step" id="questionaires">
                {sortBy(examQuestions, ["order"])?.map((item, i) => (
                  <div
                    key={i}
                    style={
                      item.order === activeStep
                        ? {
                            borderColor: item.is_correct
                              ? "#1AD304"
                              : "#F90037",
                            backgroundColor: item.is_correct
                              ? "#1AD304"
                              : "#F90037",
                            color: "white",
                            height: "32px",
                            width: "32px",
                          }
                        : item.is_correct
                        ? {
                            borderColor: "#F3F3F3",
                            backgroundColor: "#1AD304",
                            color: "white",
                          }
                        : {
                            borderColor: "#F3F3F3",
                            backgroundColor: "#F90037",
                            color: "white",
                          }
                    }
                    className="step-item"
                    onClick={() => this.handleSetSelectedPage(item.order - 1)}
                  >
                    {item.order}
                  </div>
                ))}
              </div>
              <div className="bubble-content">
                {this.renderQuestion(activeQuestion)}
              </div>
              <div className="exam-answer">
                <p className="answer-label">Your Answer:</p>
                <p className="answer">
                  {this.formatAnswer(activeQuestion.answer)}
                </p>
              </div>
              {showCorrectAnswer && (
                <div className="exam-answer">
                  <p className="answer-label">Correct Answer:</p>
                  <p className="answer">
                    {this.formatAnswer(activeQuestion.correct_answer)}
                  </p>
                </div>
              )}
              {showExplanation && activeQuestion.notes && (
                <div className="exam-answer">
                  <p className="answer-label">Explanation</p>
                  <p className="answer">{activeQuestion.notes}</p>
                </div>
              )}
            </>
          ) : (
            <Fragment>
              {(!IS_ADMIN_ROLE &&
                (isEmpty(data?.exam_submission) ||
                  data?.exam_submission.submitted)) ||
              (IS_ADMIN_ROLE && (isEmpty(examDetails) || !isAdminViewExam)) ? (
                <>
                  <h3 className="exam-title">INSTRUCTIONS</h3>
                  <p className="exam-description">{data?.exam?.description}</p>
                  <div className="exam-container">
                    <label className="exam-label">Questions</label>
                    <p className="exam-value">
                      {data?.exam?.total_questions
                        ? data?.exam?.total_questions
                        : "N/A"}
                    </p>
                  </div>
                  <div className="exam-container">
                    <label className="exam-label">Passing Rate</label>
                    <p className="exam-value">
                      {data?.exam?.passing_rate
                        ? `${data?.exam?.passing_rate}%`
                        : "None"}
                    </p>
                  </div>
                  <div className="exam-container">
                    <label className="exam-label">Maximum Attempts</label>
                    <p className="exam-value">
                      {data?.exam?.max_attempts
                        ? data?.exam?.max_attempts
                        : "Unlimited"}
                    </p>
                  </div>
                  <div className="exam-container">
                    <label className="exam-label">Attempts</label>
                    <p className="exam-value">
                      {data?.exam_submission?.attempt
                        ? data?.exam_submission?.attempt
                        : 0}
                    </p>
                  </div>
                  <div className="exam-container">
                    <label className="exam-label">Timer</label>
                    <p className="exam-value">
                      {data?.exam?.hours
                        ? `${
                            data?.exam?.hours +
                            (data?.exam?.hours === 1 ? " hour" : " hours")
                          }`
                        : ""}{" "}
                      {data?.exam?.minutes
                        ? `${
                            data?.exam?.minutes +
                            (data?.exam?.minutes === 1 ? " minute" : " minutes")
                          }`
                        : ""}
                      {data?.exam?.duration ? "" : "None"}
                    </p>
                  </div>
                  <div className="exam-container">
                    <label className="exam-label">Start Date</label>
                    <p className="exam-value">
                      {data?.exam?.date_start ? data?.exam?.date_start : "None"}
                    </p>
                  </div>
                  <div className="exam-container">
                    <label className="exam-label">End Date</label>
                    <p className="exam-value">
                      {data?.exam?.date_end ? data?.exam?.date_end : "None"}
                    </p>
                  </div>
                </>
              ) : IS_ADMIN_ROLE ? (
                this.renderExamAsAdmin(examTimer, examQuestions, activeQuestion)
              ) : (
                <Fragment>
                  {data.exam?.duration > 0 ? (
                    <div className="exam-timer">
                      <label
                        className="timer-preamble"
                        style={{ color: schoolData?.primary_color }}
                      >
                        EXAM TIMER
                      </label>
                      <p className="timer-countdown">{examTimer}</p>
                      <p className="timer-note">
                        *Timer will continue to run when you leave this page
                      </p>
                    </div>
                  ) : (
                    ""
                  )}
                  <p className="exam-subtitle">Question Progress</p>
                  <div className="bubble-step" id="questionaires">
                    {sortBy(examQuestions, ["order"])?.map((item, i) => (
                      <div
                        key={i}
                        style={
                          item.order === activeStep
                            ? {
                                borderColor: schoolData.primary_color,
                                backgroundColor: "#ffffff",
                                color: schoolData.primary_color,
                                height: "32px",
                                width: "32px",
                              }
                            : item.answer
                            ? {}
                            : {
                                borderColor: "#474b5a",
                                backgroundColor: "white",
                                color: "#474b5a",
                              }
                        }
                        className="step-item"
                        onClick={() => this.handleSelectPage(data.id, i)}
                      >
                        {item.order}
                      </div>
                    ))}
                  </div>
                  <div className="bubble-content">
                    {this.renderQuestion(activeQuestion)}
                    {this.displayExamType(activeQuestion)}
                  </div>
                  <div className="steps-actions">
                    <div className="steps-action">
                      <Button
                        label="Previous Question"
                        ghost
                        outlined
                        hidden={activeStep <= 1}
                        disabled={activeStep <= 1}
                        onClick={() => this.handlePrevious()}
                      />
                    </div>
                    <div className="steps-action">
                      <Button
                        label={
                          activeStep === data?.exam_submission?.questions.length
                            ? "Submit Exam"
                            : "Next Question"
                        }
                        onClick={() => this.handleNext(activeQuestion)}
                      />
                    </div>
                  </div>
                </Fragment>
              )}
            </Fragment>
          )}
        </div>
        {IS_ADMIN_ROLE && (
          <div className="steps-actions">
            <div className="steps-action">
              <Button
                label={isAdminViewExam ? "Hide Questions" : "View Questions"}
                outlined
                onClick={() => this.handleToggleAdminExam(data.exam?.id)}
              />
            </div>
          </div>
        )}
        {data?.exam.open &&
        role === "ST" &&
        (isEmpty(data?.exam_submission) || data?.exam_submission?.submitted) ? (
          <div className="steps-actions">
            {data?.exam_submission?.submitted ? (
              <div className="steps-action">
                <Button
                  label={showResults ? "Hide Results" : "View Results"}
                  outlined
                  onClick={() => this.handleViewResults()}
                />
              </div>
            ) : (
              ""
            )}
            <div className="steps-action">
              {(data?.exam_submission?.submitted &&
                data?.exam_submission?.passed) ||
              data?.exam_submission?.has_pending ||
              maxAttemptReached ? (
                <>
                  {data?.next && (
                    <Button
                      label="Next Courseware"
                      onClick={() => this.handleViewNextCourseWare()}
                    />
                  )}
                </>
              ) : (
                <Button
                  label={`${
                    data?.exam_submission?.submitted &&
                    !data?.exam_submission?.passed
                      ? "Retake Exam"
                      : "Start Exam"
                  }`}
                  onClick={() => this.handleStartExam(data.exam?.id)}
                />
              )}
            </div>
          </div>
        ) : (
          ""
        )}
      </>
    )
  }
}

const mapStateToProps = (state) => ({
  courses: state.coursesReducer,
  user: state.userReducer,
  school: state.schoolReducer,
  auth: state.authReducer,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      saveProgress,
      completeCourseware,
      startExam,
      submitAnswer,
      showResponseModal,
      closeResponseModal,
      getCoursewareById,
      setExamAsSubmitted,
      getExamDetails,
    },
    dispatch
  )

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withRouter
)(Exam)
